/**
 * Centralized Prefetch Configuration
 *
 * Define which routes should prefetch other routes when loaded.
 * This keeps all prefetch logic in one place for easy maintenance.
 */

import { ROUTE_NAMES } from '@/constant/routes'

/**
 * Prefetch rules mapping
 * Key: Route name that triggers prefetch (when user navigates TO this route)
 * Value: Array of route names to prefetch
 *
 * Example:
 * When user navigates to "Presentations" page, prefetch "PresentationDetail" route
 */
export const PREFETCH_RULES = {
  // When user lands on authenticated pages, prefetch editor
  [ROUTE_NAMES.HOME]: [
    ROUTE_NAMES.PRESENTATION_DETAIL,
  ],

  [ROUTE_NAMES.PRESENTATIONS]: [
    ROUTE_NAMES.PRESENTATION_DETAIL,
  ],

  [ROUTE_NAMES.SHARED_WITH_ME]: [
    ROUTE_NAMES.PRESENTATION_DETAIL,
  ],

  [ROUTE_NAMES.TEMPLATE_LIBRARY]: [
    ROUTE_NAMES.PRESENTATION_DETAIL,
  ],

  [ROUTE_NAMES.LOGIN]: [
    ROUTE_NAMES.REGISTER,
    ROUTE_NAMES.FORGOT_PASSWORD,
    ROUTE_NAMES.SSO,
  ],

  [ROUTE_NAMES.REGISTER]: [
    ROUTE_NAMES.LOGIN,
    ROUTE_NAMES.FORGOT_PASSWORD,
    ROUTE_NAMES.SSO,
  ],

  [ROUTE_NAMES.FORGOT_PASSWORD]: [
    ROUTE_NAMES.LOGIN,
  ],

  [ROUTE_NAMES.SSO]: [
    ROUTE_NAMES.LOGIN,
  ],
}

/**
 * Get routes to prefetch for a given route name
 * @param {string} routeName - Current route name
 * @returns {Array<string>} - Array of route names to prefetch
 */
export function getRoutesToPrefetch(routeName) {
  return PREFETCH_RULES[routeName] || []
}

/**
 * Check if a route has prefetch rules
 * @param {string} routeName - Route name to check
 * @returns {boolean}
 */
export function hasPrefetchRules(routeName) {
  return routeName in PREFETCH_RULES && PREFETCH_RULES[routeName].length > 0
}
